import { PlayerListItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import useGoalKeeperStats from '@amf/shared/data/hooks/useGoalKeeperStats';

interface PlayerGoalKeeperStatsProps {
  player: PlayerListItemFragment;
  title?: string;
}

function PlayerGoalKeeperStats({ player, title }: PlayerGoalKeeperStatsProps) {
  const { t } = useTranslate();
  const { stats } = useGoalKeeperStats(player.id);

  if (stats.length === 0) return null;
  return (
    <div className='PlayerStats PlayerStats--goalKeeper'>
      {title && <h2 className='PlayerStats__title'>{title}</h2>}
      <div className='PlayerStats__content'>
        <div className='PlayerStats__list'>
          <div className='PlayerStats__header'>
            <div>{t('player.stats.season')}</div>
            <div>{t('player.stats.matches')}</div>
            <div>{t('player.stats.zeroMatches')}</div>
            <div>{t('player.stats.receivedGoals')}</div>
            <div>{t('player.stats.averageReceivedGoals')}</div>
          </div>
          {stats &&
            stats.map(item => (
              <div key={item.id} className='PlayerStats__item'>
                <div>{item.season.name}</div>
                <div>{item.matches}</div>
                <div>{item.zeroMatches}</div>
                <div>{item.receivedGoals}</div>
                <div>{item.averageReceivedGoals}</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default PlayerGoalKeeperStats;
